import gql from "graphql-tag";
import { BOOKING_FRAGMENT } from '../fragment/booking';

//Get booking
export const GET_BOOKING = gql`
query getBooking($uuid: String!) {
    getBooking(uuid: $uuid) {
      ...BookingFragment
    }
}
${BOOKING_FRAGMENT}
`;